<template>
  <CModal alignment="center" size="lg" :visible="show" @close="closeModel">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">設定量表的選項</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div id="editNestMatrix" class="options-box">
        使用換行表示個別選項，或是使用下方按鈕快速加入選項。
        <!-- <span class="text-danger">上限五個</span> -->
        <div>
          <button
            v-for="item in btnList"
            :key="item"
            class="rounded p-1 my-2 ms-2 btn remark-btn btn-secondary"
            @click="addOption(item.value)"
          >
            {{ item.series }}
          </button>
        </div>
        <div>
          <div
            class="d-flex align-items-center justify-content-start col-8 my-3"
            v-for="(option, i) in matrixOptions"
            :key="i"
          >
            <span class="col-1">{{ i + 1 }}</span>
            <input
              type="text"
              class="mx-3 content rounded px-3 w-100"
              v-model="option.title"
            />
            <div class="d-flex">
              <img
                src="@/assets/icons/add.svg"
                alt="add"
                @click="addOption('', i)"
              />
              <img
                src="@/assets/icons/minus.svg"
                alt="minus"
                @click="deleteOption(i)"
              />
            </div>
          </div>
        </div>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="finishAdd">完成</CButton>
      <CButton color="light" @click="closeModel"> 取消 </CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import { ref } from '@vue/reactivity'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [
        { title: 1 },
        { title: 2 },
        { title: 3 },
        { title: 4 },
        { title: 5 },
      ],
    },
  },
  emits: ['close', 'addOption'],
  setup(props, { emit }) {
    const matrixOptions = ref(props.options)
    const defaultOptions = matrixOptions.value
    const btnList = ref([
      {
        series: '喜歡系列',
        value: [
          { title: '非常不喜歡' },
          { title: '不喜歡' },
          { title: '普通' },
          { title: '喜歡' },
          { title: '非常喜歡' },
        ],
      },
      {
        series: '滿意系列',
        value: [
          { title: '非常不滿意' },
          { title: '不滿意' },
          { title: '普通' },
          { title: '滿意' },
          { title: '非常滿意' },
        ],
      },
      {
        series: '是否系列',
        value: [{ title: '是' }, { title: '否' }],
      },
    ])
    let i = 1
    const addOption = (value, index) => {
      if (value) {
        matrixOptions.value = value
      } else {
        // if (matrixOptions.value.length < 5) {
        i = matrixOptions.value.length + 1
        // const res = [...matrixOptions.value, { type: String(i) }]
        // matrixOptions.value = res
        // }
        matrixOptions.value.splice(index + 1, 0, { type: String(i) })
      }
      i++
      const element = document.getElementById('editNestMatrix');
      if(i > 10){
        setTimeout(() => {
        element.scrollTop = element.scrollHeight;
      }, 100);
      }
    }
    const closeModel = () => {
      matrixOptions.value = defaultOptions
      emit('close')
    }
    const deleteOption = (index) => {
      if (matrixOptions.value.length > 1) {
        matrixOptions.value.splice(index, 1)
        i--
      }
    }
    const finishAdd = () => {
      emit('close')
      emit('addOption', matrixOptions.value)
    }

    return {
      matrixOptions,
      btnList,
      addOption,
      deleteOption,
      closeModel,
      finishAdd,
    }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 500px;
  overflow: scroll;
}
</style>
